<template>
	<v-container>
		<v-row>
			<v-col>
				<template v-if="$store.getters.userHasRight('pr_view')">
					<p class="display-1" id="pr">Заявки на расходы</p>

					<p class="headline">Реестр заявок</p>

					<p>На начальном экрана блока "Заявки на расходы" отображаются открытые заявки на расходы, которые вам доступны.</p>

					<p>Первыми в списке жирным шрифтом отображаются заявки, по которым вы являетесь ответственным, и от вас требуется согласование или обработка.</p>

					<p>Чтобы отобразить закрытые заявки, нажмите кнопку "Показать закрытые". Закрытыми считаются заявки, которые полностью прошли маршрут согласования, либо были закрыты руководителем отдела.</p>

					<p class="headline">Видимость заявок</p>

					<p>В реестре заявок, а также в поиске по заявкам, отображаются заявки, для которых верно хотя бы одно из условий:</p>
					<ul>
						<li>
							Вы являетесь ответственным по заявке
						</li>
						<li>
							Вы ранее были ответственным по заявке
						</li>
						<li>
							Вы - автор заявки
						</li>
						<li>
							Заявка относится к вашему департаменту и не является заявкой на выплату сотрудникам
						</li>
					</ul>

					<p class="headline">Отметки в реестре заявок</p>

					<p><div class="new_comment" title="Новый комментарий">...</div> — к заявке появился новый комментарий</p>
					<p><div class="urgent">Срочно</div> — заявка имеет срочный приоритет</p>
					<p><div class="rejected">Отклонено</div> — заявка отклонена</p>
					<p><div class="approved">Согласовано</div> — заявка согласована всеми согласующими и подлежит оплате</p>
					<p><div class="charged">Начислено</div>  — для заявок типа "выплата сотрудникам", после начисления отделом кадров</p>
					<p><div class="prepaid">Предоплачено</div> — предоплата по заявке отправлена, при этом предоплата не равна сумме заявки</p>
					<p><div class="paid">Оплачено</div> — заявка оплачена полностью</p>
					<p><div class="closed">Закрыто</div> — заявка закрыта, то есть она либо полностью прошла маршрут согласования, либо была закрыта руководителем отдела</p>

					<p class="headline">Действия с заявками из реестра заявок</p>

					<p>Из реестра заявок доступны три действия: <img src="img/print-icon.png" class="print_icon" title="Печать"> распечатать заявку, <img src="img/copy-icon.png" class="copy_icon" title="Копировать"> копировать заявку и <img src="img/del-icon.png" class="del_icon" title="Удалить"> удалить заявку. Удаление заявки возможно только для заявки, не имеющей истории согласований и комментариев.</p>

					<p class="headline">Создание новой заявки</p>

					<p>Для создания новой заявки на расход пройдите на вкладку "Заявки на расходы" в боковом меню. Далее нажмите кнопку "Новая заявка".</p>

					<v-row >
						<v-col class="subtitle-1" cols="2" >
							Поле
						</v-col>
						<v-col class="subtitle-1" cols="10" >
							Пояснения
						</v-col>
						<v-col class="red--text" cols="2" >
							Отель
						</v-col>
						<v-col cols="10">
							Если на выбор доступны несколько отелей, выберите отель
						</v-col>
						<v-col class="red--text" cols="2" >
							Бюджет
						</v-col>
						<v-col cols="10">
							<p>OpEx — операционный бюджет отеля. Используется в большинстве случаев</p>
							<p>CaPeX — бюджет капитальных затрат. Используется для крупных закупок и капитального ремонта</p>
						</v-col>
						<v-col class="red--text" cols="2" >
							Тип заявки
						</v-col>
						<v-col cols="10">
							<p>Товар — если планируется закупка товара</p>
							<p>Услуга — если планируется закупка услуги</p>
							<p>Заявка на наличные — если необходимо оплатить расходы наличными</p>
							<p>Выплата сотрудникам — если планируется дополнительная выплата сотрудникам</p>
						</v-col>
						<v-col class="red--text" cols="2" >
							Департамент
						</v-col>
						<v-col cols="10">
							Выберите департамент, на чей бюджет будет отнесен расход. От того, какой отдел вы выберите, зависит маршрут согласования заявки.
						</v-col>
						<v-col class="red--text" cols="2" >
							Статья затрат
						</v-col>
						<v-col cols="10">
							Выберите статью затрат, по которой данные расходы были забюджетированы
						</v-col>
						<v-col class="red--text" cols="2" >
							Обоснование
						</v-col>
						<v-col cols="10">
							Поясните необходимость расходов
						</v-col>
						<v-col class="red--text" cols="2" >
							Дата доставки
						</v-col>
						<v-col cols="10">
							<p>На начальном этапе дата доставки вносится инициатором как желаемая дата доставки товара/оказания услуги. Отдел закупок вправе исправить эту дату, если он невыполнима.</p>

							<p><ul>
								<li>
									Для товара укажите примерную или желаемую дату доставки.
								</li>
								<li>
									Для услуги укажите предполагаемую дату акта об оказании услуги.
								</li>
								<li>
									Для заявки на наличные укажите предполагаемую дату расходования средств.
								</li>
								<li>
									Для выплаты сотрудникам укажите последний день месяца, в котором выплата будет начислена.
								</li>
							</ul></p>

							<p>Дата доставки служит ориентиром для диаграммы прогноза расходов в сравнении с бюджетом.</p>
						</v-col>
						<v-col class="red--text" cols="2" >
							Цена, сумма
						</v-col>
						<v-col cols="10">
							Все цены в таблицу вносятся без НДС.
							Внизу таблицы отдельно справочно указывается цена с НДС. Сравнение предложений происходит по суммам без НДС.
						</v-col>
						<v-col class="red--text" cols="2" >
							Предоплата
						</v-col>
						<v-col cols="10">
							Укажите условия предоплаты.
							От суммы предоплаты зависит маршрут заявки.
							Для заявки на наличные укажите сумму, которую нужно выдать авансом.
						</v-col>
						<v-col class="red--text" cols="2" >
							Единственный поставщик
						</v-col>
						<v-col cols="10">
							Установка данной галочки указывает на невозможность закупить товар / услугу у другого поставщика и отменяет необходимые условия по количеству конкурентных предложений. Галочка доступна после ввода стоимости.
						</v-col>
						<v-col class="red--text" cols="2" >
							Диаграмма прогноз / бюджет
						</v-col>
						<v-col cols="10">
							Показывает прогноз расходов и бюджет на тот месяц, на который приходится дата доставки по выбранному департаменту и статье расходов, и на год.

							Прогноз на месяц считается на основании уже созданных и утвержденных руководителем отдела заявок на закупку и данной заявки.

							Прогноз на год считается на основании прогноза на месяц и данных P&L за прошлые периоды.
						</v-col>
					</v-row>

					<p class="headline">Маршрут согласования заявки</p>

					<p>Маршрут согласования заявки зависит от типа заявки и других условий</p>

					<v-expansion-panels v-model="panel">
						<v-expansion-panel>
							<v-expansion-panel-header>
								<div>
									Товар
								</div>
							</v-expansion-panel-header>
							<v-expansion-panel-content>
								<v-row class="pl-6 pb-4">
									<v-col class="subtitle-1" cols="2" >
										Этап
									</v-col>
									<v-col class="subtitle-1" cols="2" >
										Согласующий / Ответственный
									</v-col>
									<v-col class="subtitle-1" cols="2" >
										Условие
									</v-col>
									<v-col class="subtitle-1" cols="6" >
										Пояснение
									</v-col>

									<v-col cols="2">
										Согласование
									</v-col>
									<v-col cols="2">
										Руководитель отдела
									</v-col>
									<v-col cols="2">

									</v-col>
									<v-col cols="6">
										Согласование с руководителем отдела до передачи на проработку в отдел закупок
									</v-col>

									<v-col cols="2">
										Сбор предложений
									</v-col>
									<v-col cols="2">
										Отдел закупок
									</v-col>
									<v-col cols="2">

									</v-col>
									<v-col cols="6">
										<p>На данном этапе руководитель отдела закупок вносит реальные цены товара, конкурентные предложения и возможную дату доставки, если она отличается от желаемой.</p>

										<p>Конкурентные предложения вносятся в соответствии с SOP 1220 Purchasing:</p>

										<ul>
											<li>если сумма заявки менее 5 000 рублей, достаточно одного предложения</li>
											<li>если сумма заявки от 5 000 до 40 000 рублей, достаточно двух предложений</li>
											<li>если сумма заявки более 40 000 рублей, необходимо три предложения</li>
										</ul>
									</v-col>

									<v-col cols="2">
										Согласование
									</v-col>
									<v-col cols="2">
										Руководитель отдела
									</v-col>
									<v-col cols="2">

									</v-col>
									<v-col cols="6">
										<p>На данном этапе руководитель отдела выбирает из предложенных отделом закупок конкурентных предложений одно и направляет заявку на дальнейшее согласование. Если руководитель отдела выбрал не наименьшее по стоимости предложение, необходимо дать пояснение в специальном поле под таблицей стоимости.</p>
									</v-col>

									<v-col cols="2">
										Согласование
									</v-col>
									<v-col cols="2">
										Финансовый контролер
									</v-col>
									<v-col cols="2">

									</v-col>
									<v-col cols="6">
										Финансовый контролер проверяет соответствие бюджету, расценки и выбранную статью расходов.
									</v-col>

									<v-col cols="2">
										Согласование
									</v-col>
									<v-col cols="2">
										Генеральный менеджер
									</v-col>
									<v-col cols="2">

									</v-col>
									<v-col cols="6">
										Генеральный менеджер проверяет операционную необходимость расходов.
									</v-col>

									<v-col cols="2">
										Согласование
									</v-col>
									<v-col cols="2">
										Финансовый директор УК
									</v-col>
									<v-col class="red--text" cols="2" >
										Если сумма заявки более 500 000 рублей
									</v-col>
									<v-col cols="6">
										В случае, если сумма заявки превышает 500 000 рублей, на данном этапе она будет согласована с финансовым директором УК
									</v-col>

									<v-col cols="2">
										Согласование оплаты
									</v-col>
									<v-col cols="2">
										Финансовый контролер
									</v-col>
									<v-col class="red--text" cols="2" >
										Если установлена опция "Требуется команда ФК на оплату"
									</v-col>
									<v-col cols="6">
										Если расход согласованы, то оплату требуется отложить по кассовым или иным причинам, финансовым контролер может придержать заявку на данном этапе. Для этого нужно установить галочку "Требуется команда ФК на оплату" на этапе первичного согласования с финансовым контролером.
									</v-col>

									<v-col cols="2">
										Предоплата
									</v-col>
									<v-col cols="2">
										Бухгалтер по затратам
									</v-col>
									<v-col class="red--text" cols="2" >
										Если предоплата > 0
									</v-col>
									<v-col cols="6">
										Бухгалтер по затратам оплачивает заявку, после чего отмечает ее как оплаченную
									</v-col>

									<v-col cols="2">
										Размещение заказа
									</v-col>
									<v-col cols="2">
										Отдела закупок
									</v-col>
									<v-col class="red--text" cols="2" >
										Если предоплата = 0
									</v-col>
									<v-col cols="6">
										Отдел закупок размешает заказ
									</v-col>

									<v-col cols="2">
										Получение товара
									</v-col>
									<v-col cols="2">
										Главный склад
									</v-col>
									<v-col class="red--text" cols="2" >

									</v-col>
									<v-col cols="6">
										Получение товара на главном складе
									</v-col>

									<v-col cols="2">
										Оплата и проверка документов
									</v-col>
									<v-col cols="2">
										Бухгалтерия
									</v-col>
									<v-col class="red--text" cols="2" >
										Если постоплата > 0
									</v-col>
									<v-col cols="6">
										Финальная оплата и проверка закрывающих документов
									</v-col>

									<v-col cols="2">
										Проверка документов
									</v-col>
									<v-col cols="2">
										Бухгалтерия
									</v-col>
									<v-col class="red--text" cols="2" >
										Если постоплата = 0
									</v-col>
									<v-col cols="6">
										Проверка закрывающих документов
									</v-col>
								</v-row>
							</v-expansion-panel-content>
						</v-expansion-panel>
						<v-expansion-panel>
							<v-expansion-panel-header>
								<div>
									Услуга
								</div>
							</v-expansion-panel-header>
							<v-expansion-panel-content>
								<v-row  class="pl-6 pb-4">
									<v-col class="subtitle-1" cols="2" >
										Этап
									</v-col>
									<v-col class="subtitle-1" cols="2" >
										Согласующий / Ответственный
									</v-col>
									<v-col class="subtitle-1" cols="2" >
										Условие
									</v-col>
									<v-col class="subtitle-1" cols="6" >
										Пояснение
									</v-col>

									<v-col cols="2">
										Согласование
									</v-col>
									<v-col cols="2">
										Руководитель отдела
									</v-col>
									<v-col class="red--text" cols="2" >

									</v-col>
									<v-col cols="6">
										<p>На данном этапе автор заявки вносит реальные цены и конкурентные предложения.</p>

										<p>Конкурентные предложения вносятся в соответствии с SOP 1220 Purchasing:</p>

										<ul>
											<li>если сумма заявки менее 5 000 рублей, достаточно одного предложения</li>
											<li>если сумма заявки от 5 000 до 40 000 рублей, достаточно двух предложений</li>
											<li>если сумма заявки более 40 000 рублей, необходимо три предложения</li>
										</ul>

										<p>
											Руководитель отдела выбирает из конкурентных предложений одно и направляет заявку на дальнейшее согласование. Если руководитель отдела выбрал не наименьшее по стоимости предложение, необходимо дать пояснение в специальном поле под таблицей стоимости.
										</p>
									</v-col>

									<v-col cols="2">
										Согласование
									</v-col>
									<v-col cols="2">
										Финансовый контролер
									</v-col>
									<v-col class="red--text" cols="2" >

									</v-col>
									<v-col cols="6">
										Финансовый контролер проверяет соответствие бюджету, расценки и выбранную статью расходов.
									</v-col>

									<v-col cols="2">
										Согласование
									</v-col>
									<v-col cols="2">
										Генеральный менеджер
									</v-col>
									<v-col class="red--text" cols="2" >

									</v-col>
									<v-col cols="6">
										Генеральный менеджер проверяет операционную необходимость расходов.
									</v-col>

									<v-col cols="2">
										Согласование
									</v-col>
									<v-col cols="2">
										Финансовый директор УК
									</v-col>
									<v-col class="red--text" cols="2" >
										Если сумма заявки более 500 000 рублей
									</v-col>
									<v-col cols="6">
										В случае, если сумма заявки превышает 500 000 рублей, на данном этапе она будет согласована с финансовым директором УК
									</v-col>

									<v-col cols="2">
										Согласование оплаты
									</v-col>
									<v-col cols="2">
										Финансовый контролер
									</v-col>
									<v-col class="red--text" cols="2" >
										Если установлена опция "Требуется команда ФК на оплату"
									</v-col>
									<v-col cols="6">
										Если расход согласованы, то оплату требуется отложить по кассовым или иным причинам, финансовым контролер может придержать заявку на данном этапе. Для этого нужно установить галочку "Требуется команда ФК на оплату" на этапе первичного согласования с финансовым контролером.
									</v-col>

									<v-col cols="2">
										Предоплата
									</v-col>
									<v-col cols="2">
										Бухгалтер по затратам
									</v-col>
									<v-col class="red--text" cols="2" >
										Если предоплата > 0
									</v-col>
									<v-col cols="6">
										Бухгалтер по затратам оплачивает заявку, после чего отмечает ее как оплаченную
									</v-col>

									<v-col cols="2">
										Размещение заказа
									</v-col>
									<v-col cols="2">
										Руководитель отдела
									</v-col>
									<v-col class="red--text" cols="2" >
										Если предоплата = 0
									</v-col>
									<v-col cols="6">
										Руководитель отдела размешает заказ и договаривается с поставщиком
									</v-col>

									<v-col cols="2">
										Получение услуги
									</v-col>
									<v-col cols="2">
										Руководитель отдела
									</v-col>
									<v-col class="red--text" cols="2" >

									</v-col>
									<v-col cols="6">
										Руководитель отдела подтверждается получение услуги и закрывающих документов
									</v-col>

									<v-col cols="2">
										Оплата и проверка документов
									</v-col>
									<v-col cols="2">
										Бухгалтерия
									</v-col>
									<v-col class="red--text" cols="2" >
										Если постоплата > 0
									</v-col>
									<v-col cols="6">
										Финальная оплата и проверка закрывающих документов
									</v-col>

									<v-col cols="2">
										Проверка документов
									</v-col>
									<v-col cols="2">
										Бухгалтерия
									</v-col>
									<v-col class="red--text" cols="2" >
										Если постоплата = 0
									</v-col>
									<v-col cols="6">
										Проверка закрывающих документов
									</v-col>
								</v-row>
							</v-expansion-panel-content>
						</v-expansion-panel>
						<v-expansion-panel>
							<v-expansion-panel-header>
								<div>
									Заявка на наличные
								</div>
							</v-expansion-panel-header>
							<v-expansion-panel-content>
								<v-row  class="pl-6 pb-4">
									<v-col class="subtitle-1" cols="2" >
										Этап
									</v-col>
									<v-col class="subtitle-1" cols="2" >
										Согласующий / Ответственный
									</v-col>
									<v-col class="subtitle-1" cols="2" >
										Условие
									</v-col>
									<v-col class="subtitle-1" cols="6" >
										Пояснение
									</v-col>

									<v-col cols="2">
										Согласование
									</v-col>
									<v-col cols="2">
										Руководитель отдела
									</v-col>
									<v-col class="red--text" cols="2" >

									</v-col>
									<v-col cols="6">
										<p>На данном этапе автор заявки вносит реальные цены и конкурентные предложения.</p>

										<p>Конкурентные предложения вносятся в соответствии с SOP 1220 Purchasing:</p>

										<ul>
											<li>если сумма заявки менее 5 000 рублей, достаточно одного предложения</li>
											<li>если сумма заявки от 5 000 до 40 000 рублей, достаточно двух предложений</li>
											<li>если сумма заявки более 40 000 рублей, необходимо три предложения</li>
										</ul>

										<p>
											Руководитель отдела выбирает из конкурентных предложений одно и направляет заявку на дальнейшее согласование. Если руководитель отдела выбрал не наименьшее по стоимости предложение, необходимо дать пояснение в специальном поле под таблицей стоимости.
										</p>
									</v-col>

									<v-col cols="2">
										Согласование
									</v-col>
									<v-col cols="2">
										Финансовый контролер
									</v-col>
									<v-col class="red--text" cols="2" >

									</v-col>
									<v-col cols="6">
										Финансовый контролер проверяет соответствие бюджету, расценки и выбранную статью расходов.
									</v-col>

									<v-col cols="2">
										Согласование
									</v-col>
									<v-col cols="2">
										Генеральный менеджер
									</v-col>
									<v-col class="red--text" cols="2" >

									</v-col>
									<v-col cols="6">
										Генеральный менеджер проверяет операционную необходимость расходов.
									</v-col>

									<v-col cols="2">
										Согласование
									</v-col>
									<v-col cols="2">
										Финансовый директор УК
									</v-col>
									<v-col class="red--text" cols="2" >
										Если сумма заявки более 500 000 рублей
									</v-col>
									<v-col cols="6">
										В случае, если сумма заявки превышает 500 000 рублей, на данном этапе она будет согласована с финансовым директором УК
									</v-col>

									<v-col cols="2">
										Согласование оплаты
									</v-col>
									<v-col cols="2">
										Финансовый контролер
									</v-col>
									<v-col class="red--text" cols="2" >
										Если установлена опция "Требуется команда ФК на оплату"
									</v-col>
									<v-col cols="6">
										Если расход согласованы, то оплату требуется отложить по кассовым или иным причинам, финансовым контролер может придержать заявку на данном этапе. Для этого нужно установить галочку "Требуется команда ФК на оплату" на этапе первичного согласования с финансовым контролером.
									</v-col>

									<v-col cols="2">
										Выдача аванса
									</v-col>
									<v-col cols="2">
										Главный кассир
									</v-col>
									<v-col class="red--text" cols="2" >
										Если предоплата > 0
									</v-col>
									<v-col cols="6">
										Главный кассир выдает наличные в соответствии с суммой предоплаты по заявке
									</v-col>

									<v-col cols="2">
										Расходование средств
									</v-col>
									<v-col cols="2">
										Руководитель отдела
									</v-col>
									<v-col class="red--text" cols="2" >

									</v-col>
									<v-col cols="6">
										Руководитель отдела расходует средства, собирает чеки и сдает их главному кассиру
									</v-col>

									<v-col cols="2">
										Расчет
									</v-col>
									<v-col cols="2">
										Главный кассир
									</v-col>
									<v-col class="red--text" cols="2" >
										Если постоплата > 0
									</v-col>
									<v-col cols="6">
										Расчет с подотчетным лицом и проверка чеков
									</v-col>

									<v-col cols="2">
										Проверка чеков
									</v-col>
									<v-col cols="2">
										Главный кассир
									</v-col>
									<v-col class="red--text" cols="2" >
										Если постоплата = 0
									</v-col>
									<v-col cols="6">
										Расчет с подотчетным лицом и проверка чеков
									</v-col>
								</v-row>
							</v-expansion-panel-content>
						</v-expansion-panel>
						<v-expansion-panel>
							<v-expansion-panel-header>
								<div>
									Выплата сотрудникам
								</div>
							</v-expansion-panel-header>
							<v-expansion-panel-content>
								<v-row  class="pl-6 pb-4">
									<v-col class="subtitle-1" cols="2" >
										Этап
									</v-col>
									<v-col class="subtitle-1" cols="2" >
										Согласующий / Ответственный
									</v-col>
									<v-col class="subtitle-1" cols="2" >
										Условие
									</v-col>
									<v-col class="subtitle-1" cols="6" >
										Пояснение
									</v-col>

									<v-col cols="2">
										Согласование
									</v-col>
									<v-col cols="2">
										Руководитель отдела
									</v-col>
									<v-col class="red--text" cols="2" >

									</v-col>
									<v-col cols="6">
										<p>На данном этапе автора заявки вносит суммы выплаты.</p>
									</v-col>

									<v-col cols="2">
										Согласование
									</v-col>
									<v-col cols="2">
										Финансовый контролер
									</v-col>
									<v-col class="red--text" cols="2" >

									</v-col>
									<v-col cols="6">
										Финансовый контролер проверяет соответствие бюджету, политике оплаты труда и выбранную статью расходов.
									</v-col>

									<v-col cols="2">
										Согласование
									</v-col>
									<v-col cols="2">
										Генеральный менеджер
									</v-col>
									<v-col class="red--text" cols="2" >

									</v-col>
									<v-col cols="6">
										Генеральный менеджер проверяет операционную необходимость расходов.
									</v-col>

									<v-col cols="2">
										Согласование
									</v-col>
									<v-col cols="2">
										Финансовый директор УК
									</v-col>
									<v-col class="red--text" cols="2" >
										Если сумма заявки более 500 000 рублей
									</v-col>
									<v-col cols="6">
										В случае, если сумма заявки превышает 500 000 рублей, на данном этапе она будет согласована с финансовым директором УК
									</v-col>

									<v-col cols="2">
										Согласование оплаты
									</v-col>
									<v-col cols="2">
										Финансовый контролер
									</v-col>
									<v-col class="red--text" cols="2" >
										Если установлена опция "Требуется команда ФК на оплату"
									</v-col>
									<v-col cols="6">
										Если расход согласованы, то оплату требуется отложить по кассовым или иным причинам, финансовым контролер может придержать заявку на данном этапе. Для этого нужно установить галочку "Требуется команда ФК на оплату" на этапе первичного согласования с финансовым контролером.
									</v-col>

									<v-col cols="2">
										Начисление выплаты
									</v-col>
									<v-col cols="2">
										Отдел кадров
									</v-col>
									<v-col class="red--text" cols="2" >

									</v-col>
									<v-col cols="6">
										Сумма начисляется отделом кадров
									</v-col>
								</v-row>
							</v-expansion-panel-content>
						</v-expansion-panel>
					</v-expansion-panels>

					<p class="headline">Пояснения к кнопкам</p>

					<v-row >
						<v-col class="subtitle-1" cols="2" >
							Кнопка
						</v-col>
						<v-col class="subtitle-1" cols="10" >
							Действие
						</v-col>
						<v-col class="red--text" cols="2" >
							Согласовать
						</v-col>
						<v-col cols="10">
							Заявка будет согласована и перейдет на следующий этап.
						</v-col>
						<v-col class="red--text" cols="2" >
							Отозвать решение
						</v-col>
						<v-col cols="10">
							Ваше решение будет отозвано и заявка вернется к вам. Кнопка доступна только в том случае, если после вашего согласование никто другой не согласовал заявку.
						</v-col>
						<v-col class="red--text" cols="2" >
							Отклонить
						</v-col>
						<v-col cols="10">
							Заявка будет помечена как отклоненная и вернется инициатору, который может сбросить согласования и внести в нее изменения при необходимости.
						</v-col>
						<v-col class="red--text" cols="2" >
							Вернуть руководителю
						</v-col>
						<v-col cols="10">
							Согласования будут сброшены и заявка будет возвращена руководителю отдела.
						</v-col>
						<v-col class="red--text" cols="2" >
							Вернуть себе
						</v-col>
						<v-col cols="10">
							Если вы руководитель отдела, согласования будут сброшены и заявка будет возвращена вам.
						</v-col>
						<v-col class="red--text" cols="2" >
							Вернуть в отдел закупок
						</v-col>
						<v-col cols="10">
							Согласования после отдела закупок будут сброшены и заявка будет возвращена в отдел закупок. Доступно только для заявок типа "товар"
						</v-col>
						<v-col class="red--text" cols="2" >
							Редактировать
						</v-col>
						<v-col cols="10">
							Позволяет редактировать заявку:
							<ul>
								<li>
									на этапе создания, перед всеми согласованиями, руководитель отдела может редактировать любые поля формы.
								</li>
								<li>
									на этапе сбора предложений, после первичного согласования руководителем отдела, отдел закупок может редактировать цены и дату доставки.
								</li>
								<li>
									на этапе согласования финансовым контролером, после финального согласования руководителем отдела, финансовый контролер может редактировать статью расходов.
								</li>
							</ul>
						</v-col>
						<v-col class="red--text" cols="2" >
							Копировать заявку
						</v-col>
						<v-col cols="10">
							Будет создана копия данной заявки без согласований.
						</v-col>
						<v-col class="red--text" cols="2" >
							Удалить заявку
						</v-col>
						<v-col cols="10">
							Удаляет заявку. Доступно только для заявки, у которой нет истории согласований.
						</v-col>
						<v-col class="red--text" cols="2" >
							Реестр заявок
						</v-col>
						<v-col cols="10">
							Вернуться на страницу с реестром всех заявок.
						</v-col>
						<v-col class="red--text" cols="2" >
							Следующая
						</v-col>
						<v-col cols="10">
							Переход к следующей заявке из списка заявок, по которым требуется ваше действие.
						</v-col>
						<v-col class="red--text" cols="2" >
							Печать
						</v-col>
						<v-col cols="10">
							Будет сформирована печатная форма заявки в PDF.
						</v-col>
					</v-row>
				</template>

				<template v-if="$store.getters.userHasRight('drr_data_view')">
					<p class="display-1" id="drr-view">Просмотр отчетов DRR</p>

					<p class="headline">Отчет за день</p>

					<p>Отчет за день позволяет сформировать отчет за любую загруженную дату по любому из доступных отелей.</p>

					<p>Доступные настройки:</p>

					<v-row >
						<v-col class="red--text" cols="2" >
							Отель
						</v-col>
						<v-col cols="10">
							Отель из списка доступных
						</v-col>
						<v-col class="red--text" cols="2" >
							Дата
						</v-col>
						<v-col cols="10">
							Дата отчета
						</v-col>
					</v-row>

					<p class="headline">Отчет за период</p>

					<p>Отчет за период позволяет сформировать отчет за период времени по любому из доступных отелей.</p>

					<p>Доступные настройки:</p>

					<v-row >
						<v-col class="red--text" cols="3" >
							Отель
						</v-col>
						<v-col cols="9">
							Отель из списка доступных
						</v-col>
						<v-col class="red--text" cols="3" >
							Дата с
						</v-col>
						<v-col cols="9">
							Дата начала отчета
						</v-col>
						<v-col class="red--text" cols="3" >
							Дата по
						</v-col>
						<v-col cols="9">
							Дата конца отчета
						</v-col>
						<v-col class="red--text" cols="3" >
							Показать график выручки
						</v-col>
						<v-col cols="9">
							К отчету будет добавлен график выручки
						</v-col>
						<v-col class="red--text" cols="3" >
							Показать проданные номера и каверсы
						</v-col>
						<v-col cols="9">
							К отчету будет добавлены данные по проданным номерам и чекам F&B
						</v-col>
					</v-row>
				</template>

				<template v-if="$store.getters.userHasRight('pl_data_view')">
					<p class="display-1" id="pl-view">Просмотр отчетов PL</p>

					<p>На вкладке P&L Отчеты представлен список доступных отчетов по данным P&L. Цифры во всех очтетах без НДС.</p>

					<p class="headline">Отчет за месяц</p>

					<p>Доступные настройки:</p>

					<v-row >
						<v-col class="red--text" cols="3" >
							Отель
						</v-col>
						<v-col cols="9">
							Отель из списка доступных
						</v-col>
						<v-col class="red--text" cols="3" >
							Департамент
						</v-col>
						<v-col cols="9">
							Для формирования отчета по всем департаментам, выберите "Полный отчет", для отчета по конкретному департаменту, выберите этот департамент
						</v-col>
						<v-col class="red--text" cols="3" >
							Месяц
						</v-col>
						<v-col cols="9">
							Месяц отчета
						</v-col>
						<v-col class="red--text" cols="3" >
							Тип отчета
						</v-col>
						<v-col cols="9">
							<p>Финансовые результаты - финансовые результаты отеля в стандартном формате P&L. Отчет в тысячах рублей.</p>
							<p>Метрики - аналитические показатели, основанные на данных P&L. Отчет в рублях.</p>
						</v-col>
						<v-col class="red--text" cols="3" >
							Язык
						</v-col>
						<v-col cols="9">
							Язык отчета
						</v-col>
						<v-col class="red--text" cols="3" >
							В тысячах
						</v-col>
						<v-col cols="9">
							Формирование отчет в тысячах рублей. Доступно только для отчетов с типом "Финансовые результаты"
						</v-col>
						<v-col class="red--text" cols="3" >
							Показывать нулевые строки
						</v-col>
						<v-col cols="9">
							Показывать все строки USALI, в том числе те, по которым во всех столбцах стоят нули
						</v-col>
					</v-row>

					<p class="headline">Отчет за 3 месяца</p>

					<p>
						Отчет три месяца, сравнение либо с бюджетом, либо прошлым годом. Данные представлены помесячно.
					</p>

					<p>Доступные настройки:</p>

					<v-row >
						<v-col class="red--text" cols="3" >
							Отель
						</v-col>
						<v-col cols="9">
							Отель из списка доступных
						</v-col>
						<v-col class="red--text" cols="3" >
							Департамент
						</v-col>
						<v-col cols="9">
							Для формирования отчета по всем департаментам, выберите "Полный отчет", для отчета по конкретному департаменту, выберите этот департамент
						</v-col>
						<v-col class="red--text" cols="3" >
							Первый месяц
						</v-col>
						<v-col cols="9">
							Первый месяц отчета
						</v-col>
						<v-col class="red--text" cols="3" >
							Последний месяц
						</v-col>
						<v-col cols="9">
							Последний месяц отчета
						</v-col>
						<v-col class="red--text" cols="3" >
							Сравнение с
						</v-col>
						<v-col cols="9">
							Какие данные добавить в отчет, помимо фактических - бюджетные или за прошлый год
						</v-col>
						<v-col class="red--text" cols="3" >
							Тип отчета
						</v-col>
						<v-col cols="9">
							<p>Финансовые результаты - финансовые результаты отеля в стандартном формате P&L. Отчет в тысячах рублей.</p>
							<p>Метрики - аналитические показатели, основанные на данных P&L. Отчет в рублях.</p>
						</v-col>
						<v-col class="red--text" cols="3" >
							Язык
						</v-col>
						<v-col cols="9">
							Язык отчета
						</v-col>
						<v-col class="red--text" cols="3" >
							В тысячах
						</v-col>
						<v-col cols="9">
							Формирование отчет в тысячах рублей. Доступно только для отчетов с типом "Финансовые результаты"
						</v-col>
						<v-col class="red--text" cols="3" >
							Показывать нулевые строки
						</v-col>
						<v-col cols="9">
							Показывать все строки USALI, в том числе те, по которым во всех столбцах стоят нули
						</v-col>
					</v-row>

					<p class="headline">Отчет за 12 месяцев</p>

					<p>
						Отчет за 12 месяцев одного года. Только фактические данные.
					</p>

					<p>Доступные настройки:</p>

					<v-row >
						<v-col class="red--text" cols="3" >
							Отель
						</v-col>
						<v-col cols="9">
							Отель из списка доступных
						</v-col>
						<v-col class="red--text" cols="3" >
							Департамент
						</v-col>
						<v-col cols="9">
							Для формирования отчета по всем департаментам, выберите "Полный отчет", для отчета по конкретному департаменту, выберите этот департамент
						</v-col>
						<v-col class="red--text" cols="3" >
							Год
						</v-col>
						<v-col cols="9">
							Год отчета
						</v-col>
						<v-col class="red--text" cols="3" >
							Тип отчета
						</v-col>
						<v-col cols="9">
							<p>Финансовые результаты - финансовые результаты отеля в стандартном формате P&L. Отчет в тысячах рублей.</p>
							<p>Метрики - аналитические показатели, основанные на данных P&L. Отчет в рублях.</p>
						</v-col>
						<v-col class="red--text" cols="3" >
							Язык
						</v-col>
						<v-col cols="9">
							Язык отчета
						</v-col>
						<v-col class="red--text" cols="3" >
							В тысячах
						</v-col>
						<v-col cols="9">
							Формирование отчет в тысячах рублей. Доступно только для отчетов с типом "Финансовые результаты"
						</v-col>
						<v-col class="red--text" cols="3" >
							Показывать нулевые строки
						</v-col>
						<v-col cols="9">
							Показывать все строки USALI, в том числе те, по которым во всех столбцах стоят нули
						</v-col>
						<v-col class="red--text" cols="3" >
							Показывать % для каждого месяца
						</v-col>
						<v-col cols="9">
							Показывать столбец процентов для каждого месяца
						</v-col>
					</v-row>

					<p class="headline">Отчет за квартал</p>

					<p>
						Отчет за календарный квартал, сравнение с бюджетом и прошлым годом, данные представлены за этот квартал и накопительным итогом с начала года.
					</p>

					<p>Доступные настройки:</p>

					<v-row >
						<v-col class="red--text" cols="3" >
							Отель
						</v-col>
						<v-col cols="9">
							Отель из списка доступных
						</v-col>
						<v-col class="red--text" cols="3" >
							Департамент
						</v-col>
						<v-col cols="9">
							Для формирования отчета по всем департаментам, выберите "Полный отчет", для отчета по конкретному департаменту, выберите этот департамент
						</v-col>
						<v-col class="red--text" cols="3" >
							Квартал
						</v-col>
						<v-col cols="9">
							Квартал отчета
						</v-col>
						<v-col class="red--text" cols="3" >
							Тип отчета
						</v-col>
						<v-col cols="9">
							<p>Финансовые результаты - финансовые результаты отеля в стандартном формате P&L. Отчет в тысячах рублей.</p>
							<p>Метрики - аналитические показатели, основанные на данных P&L. Отчет в рублях.</p>
						</v-col>
						<v-col class="red--text" cols="3" >
							Язык
						</v-col>
						<v-col cols="9">
							Язык отчета
						</v-col>
						<v-col class="red--text" cols="3" >
							В тысячах
						</v-col>
						<v-col cols="9">
							Формирование отчет в тысячах рублей. Доступно только для отчетов с типом "Финансовые результаты"
						</v-col>
						<v-col class="red--text" cols="3" >
							Показывать нулевые строки
						</v-col>
						<v-col cols="9">
							Показывать все строки USALI, в том числе те, по которым во всех столбцах стоят нули
						</v-col>
					</v-row>

					<p class="headline">Отчет за 4 квартала</p>

					<p>
						Отчет за 4 квартала одного года квартал, сравнение либо с бюджетом, либо прошлым годом, данные представлены поквартально.
					</p>

					<p>Доступные настройки:</p>

					<v-row >
						<v-col class="red--text" cols="3" >
							Отель
						</v-col>
						<v-col cols="9">
							Отель из списка доступных
						</v-col>
						<v-col class="red--text" cols="3" >
							Департамент
						</v-col>
						<v-col cols="9">
							Для формирования отчета по всем департаментам, выберите "Полный отчет", для отчета по конкретному департаменту, выберите этот департамент
						</v-col>
						<v-col class="red--text" cols="3" >
							Год
						</v-col>
						<v-col cols="9">
							Год отчета
						</v-col>
						<v-col class="red--text" cols="3" >
							Сравнение с
						</v-col>
						<v-col cols="9">
							Какие данные добавить в отчет, помимо фактических - бюджетные или за прошлый год
						</v-col>
						<v-col class="red--text" cols="3" >
							Тип отчета
						</v-col>
						<v-col cols="9">
							<p>Финансовые результаты - финансовые результаты отеля в стандартном формате P&L. Отчет в тысячах рублей.</p>
							<p>Метрики - аналитические показатели, основанные на данных P&L. Отчет в рублях.</p>
						</v-col>
						<v-col class="red--text" cols="3" >
							Язык
						</v-col>
						<v-col cols="9">
							Язык отчета
						</v-col>
						<v-col class="red--text" cols="3" >
							В тысячах
						</v-col>
						<v-col cols="9">
							Формирование отчет в тысячах рублей. Доступно только для отчетов с типом "Финансовые результаты"
						</v-col>
						<v-col class="red--text" cols="3" >
							Показывать нулевые строки
						</v-col>
						<v-col cols="9">
							Показывать все строки USALI, в том числе те, по которым во всех столбцах стоят нули
						</v-col>
					</v-row>

					<p class="headline">Годовой бюджет</p>

					<p>
						Бюджетные данные за год, представленые помесячно.
					</p>

					<p>Доступные настройки:</p>

					<v-row >
						<v-col class="red--text" cols="3" >
							Отель
						</v-col>
						<v-col cols="9">
							Отель из списка доступных
						</v-col>
						<v-col class="red--text" cols="3" >
							Департамент
						</v-col>
						<v-col cols="9">
							Для формирования отчета по всем департаментам, выберите "Полный отчет", для отчета по конкретному департаменту, выберите этот департамент
						</v-col>
						<v-col class="red--text" cols="3" >
							Год
						</v-col>
						<v-col cols="9">
							Год отчета
						</v-col>
						<v-col class="red--text" cols="3" >
							Тип отчета
						</v-col>
						<v-col cols="9">
							<p>Финансовые результаты - финансовые результаты отеля в стандартном формате P&L. Отчет в тысячах рублей.</p>
							<p>Метрики - аналитические показатели, основанные на данных P&L. Отчет в рублях.</p>
						</v-col>
						<v-col class="red--text" cols="3" >
							Язык
						</v-col>
						<v-col cols="9">
							Язык отчета
						</v-col>
						<v-col class="red--text" cols="3" >
							В тысячах
						</v-col>
						<v-col cols="9">
							Формирование отчет в тысячах рублей. Доступно только для отчетов с типом "Финансовые результаты"
						</v-col>
						<v-col class="red--text" cols="3" >
							Показывать нулевые строки
						</v-col>
						<v-col cols="9">
							Показывать все строки USALI, в том числе те, по которым во всех столбцах стоят нули
						</v-col>
						<v-col class="red--text" cols="3" >
							Показывать % для каждого месяца
						</v-col>
						<v-col cols="9">
							Показывать столбец процентов для каждого месяца
						</v-col>
					</v-row>
				</template>

				<template v-if="$store.getters.userHasRight('drr_input')">
					<p class="display-1" id="drr-input">Ввод данных DRR</p>

					<p> Отчеты отправляются через форму на вкладке "DRR Ввод данных". Если пользователю доступны права по отправке отчетов сразу за несколько отелей, то перед заполнением данных, нужно выбрать отель.</p>

					<p> Если отчет по данному отелю отправляется впервые, необходимо ввести дату отчета. После этого дата отчета проставляется автоматически. </p>

					<p> Данные вводятся в рублях, без копеек, без НДС. </p>

					<p> Нулевые значения можно не вводить, оставляя поле пустым. </p>

					<p> Итоговые суммы выручки заполняются автоматически, при этом необходимо обязательно сверять эти суммы с отчетами PMS. </p>

					<p> Прогнозная загрузка по дням и месяцам вводится в процентах, без знака "%" и без дробных значений. </p>

					<p> В поле Comments необходимо внести любые комментарии по отчету, поясняющие возможные отклонения от нормы. </p>
				</template>

				<template v-if="$store.getters.userHasRight('pl_input')
					|| $store.getters.userHasRight('pl_input_rooms')
					|| $store.getters.userHasRight('pl_input_fb')
					|| $store.getters.userHasRight('pl_input_hr')
					|| $store.getters.userHasRight('pl_input_utilities')
					|| $store.getters.userHasRight('pl_input_laundry')
					|| $store.getters.userHasRight('pl_input_sd')
					|| $store.getters.userHasRight('pl_bud_direct_input')
					|| $store.getters.userHasRight('pl_direct_input')">
					<p class="display-1" id="pl-input">Ввод данных P&L</p>
					<p class="headline">Импорт данных из программы бухгалтерского учета</p>

					<p>Для импорта данных из программы бухгалтерского учета, данные должны быть подготовлены в виде таблицы в формате CSV. Каждая строка таблицы должна содержать данные в следующем формате:</p>

					<p>[код отдела];[код статьи];[сумма]</p>

					<p>Расходы указываются без знака минус. Все суммы указываются с тем знаком, с которым они будут выведены на финальный лист P&L.</p>

					<p>Следующие данные вводятся HOD через соответствующие формы и не загружаются через импорт:</p>

					<p>- по количеству проданных номеров</p>
					<p>- по количеству чеков/гостей F&B</p>
					<p>- по количеству отработанных часов персонала</p>
					<p>- по количественным показателям коммунальных расходов</p>
					<p>- по распредленнию расходов House Laundry / Staff Dining</p>

					<p>Для импорта можно загружать данные из бухгалтерского учета напокительно с начала года. В этом случае в систему выбранным месяцем загрузится разница между уже имеющимися данными и загружаемыми данными бухгалтерского учета. Данный вариант следует использовать при наличии изменений в данных бухгалтерского учета в периодах, уже закрытых по P&L</p>


					<p>Для удаления загруженных данных можно использовать кнопку "Очистить". Будут стерты данные, загруженные через импорт. Данные, введенные HOD, резервы, корректировки и дополнения останутся неизмененными.</p>

					<p>Отклонения от данных бухгалтерского учета заносятся через форму внесения резервов/дополнений/корректировок</p>

					<p class="headline">Резервы</p>

					<p>Используются в случае необходимости отразить доходы (расходы), которые по определенным причинам не могут быть внесены в бухгалерский учет, но появятся в нем позднее. Все резервы должны быть впоследствии сторнированы. Данные вносятся в рублях.</p>

					<p class="headline">Дополнения</p>

					<p>Используются в случае необходимости дополнить данные бухгалтерского учета доходами (расходам), которые бухгалтерском учете никогда не появятся. Дополнения не сторнируются. Должны быть использованы по согласованию с собственником. Данные вносятся в рублях.</p>

					<p class="headline">Корректировки</p>

					<p>Используются в случае необходимости скорректировать загруженные данные бухгалтерского учета, изменив статью расходов, либо период. Сумма корректировок всегда должна равняться нулю. Возможна корректировка уже отправленных отчетов при условии что сумма GOP и сумма выручки не меняется. Данные вносятся в рублях.</p>

					<p class="headline">Данные от HOD</p>

					<p>Руководители департментов вносят данные, необходимые для расчета P&L. Финансовый контролер взаимодействует с HOD для обеспечания корректности ввода данных.</p>

					<p><span class="red--text">Rooms</span> - количество проданных номеров по маркет кодам за месяц, колечество заездов за месяц. Вносится руководителем FO.</p>
					<p><span class="red--text">Food & Beverage</span> - количество чеков и гостей, обслуженных за месяц. Вносится руководителем F&B.</p>
					<p><span class="red--text">Human Resources</span> - количество отработанных часов за месяц по отделам, списочная численность отделов, количество приемов и увольнений по отделам. Вносится руководителем HR.</p>
					<p><span class="red--text">Utilities</span> - количественные показатели по коммунальным расходам. Вносятся главным инженером.</p>
					<p><span class="red--text">House Laundry</span> - количество отстиранных килограмм униформы и белья, химчистка по отделам. Вносится руководителем HSKP</p>
					<p><span class="red--text">Staff Dining</span> - количество обедов в служебной столовой по отделам. Вносится руководителем F&B</p>

					<p><b>N.B.</b> Распределение отработанных часов по отделам, в том числе распределение на management/non-management должно быть согласовано с распределением, используемым финансовым контролером для отражения затрат в P&L. В данном вопросе требуется взаимодействие HR с FC.</p>

					<p class="headline">Отправка и согласование отчета P&L</p>

					<p>Отправка и согласование отчетов P&L происходит на странице "P&L Согласование". После внесения данных бухгалтерского учета, резервов, дополнений, корректировок и данных от HOD, финансовый контролер вносит свои комментарии к отчету, далее отчет отправляется на утверждение GM. Отправка отчета становится доступной только после ввода всех данных от HOD.</p>

					<p>GM, ознакомившись с отчетом, вносит свои комментарии к отчету и отправляет отчет в управляющую компанию. В случае если в отчет, отправленный на утверждение GM, нуждается в корректировке, он может быть отозван финансовым контролером для внесения изменений. После утверждения отчета GM и отправки отчета в УК, отчет не может быть скорректирован.</p>

					<p>Просмотр неотправленного отчета P&L возможен из выпадающего меня отчета.</p>
				</template>

				<template v-if="$store.getters.userHasRight('pl_input')">
					<p class="display-1" id="pl-forecast">Прогнозы P&L</p>

					<p>Прогнозные данные вносятся на странице P&L Прогноз. Данные вносятся вручную, либо копированием из excel. При копировании из excel есть возможность копировать столбец данных, он будет вставлен в столбец таблицы ввода.</p>

					<p>Периодчность отправки прогнозов P&L определяется SOP / LSOP. Система не делает напоминаний о необходимости отправки прогноза, поэтому отслеживание сроков является ответственностью финансового контролера.</p>

					<p>При вводе прогноза происходит его сравнение с бюджетом / прошлым годом / прошлым прогнозом. Переключение объектов сравнения происходит путем нажатия на необходимый объект в шапке таблицы.</p>

					<p>После нажатия кнопки "Отправить прогноз" будет показано всплывающее окно с проверочными показателями ADR, Total Revenue, GOP.</p>

					<p>После подтверждения отправки отчета, прогноз будет отправлен генеральному менеджеру, в управляющую компанию, а также другим получателям прогнозов, которые указаны в параметрах отеля в графе "Получатели прогнозных P&L".</p>
				</template>

				<template v-if="$store.getters.userHasRight('pl_input')
					|| $store.getters.userHasRight('pl_approve')
					|| $store.getters.userHasRight('pl_ho_approve')
					|| $store.getters.userHasRight('pl_owner_approve')">
					<p class="display-1" id="pl-budgets">Бюджеты P&L</p>
					<p class="headline">Ввод бюджетов</p>

					<p>Создание нового бюджета происходит путем нажатия кнопки "+" на странице P&L Бюджеты. Единственное, что при этом необходимо выбрать, это отель и период бюджетирования. Все остальные данные вносятся на следующих этапах.</p>

					<p>Один бюджет может содержать несколько версий. Каждая версия состоит из</p>

					<p><ul>
						<li>финансовых и количественных показателей, которые импортируются через CSV файл</li>
						<li>комментариев к этой версии</li>
					</ul></p>

					<p>А также из приложенных файлов:</p>

					<p><ul>
						<li>бюджета в формате владельца в формате excel</li>
						<li>описательной части в формате word</li>
						<li>презентации в формате powerpoint, pdf</li>
						<li>любых других файлов</li>
					</ul></p>

					<p>Для загрузки новой версии нажмите кнопки "Новая версия". Данные должны быть подготовлены в виде таблицы в формате CSV. Каждая строка таблицы должна содержать данные в следующем формате:</p>

					<p>[год];[месяц];[код отдела];[код статьи];[сумма]</p>

					<p>При загрузке второй и последующих версий, если файлы приложения не изменились, можно установить галочку "Взять из предыдущей версии", чтобы не загружать один и тот же файл несколько раз.</p>

					<p><b>N.B.</b>При загрузке второй и последующих версий всегда оставляйте комментарии, чем данная версия отличается от предыдущих.</p>

					<p>Редактирование версии бюджета возможно только на первом этапе - Согласование FC, а также только тех версий, которые еще не были согласованы GM.</p>

					<p>Пример: если GM согласовал бюджет, а потом отозвал согласование, после чего FC также отозвал свое согласования, последняя версия бюджет не будет доступна для редактирования.</p>

					<p class="headline">Согласование бюджетов</p>

					<p>Бюджет проходит следующие этапы согласования:</p>

					<p><ul>
						<li>Согласование FC (финансовым контролером отеля)</li>
						<li>Согласование GM (генеральным менеджером отеля)</li>
						<li>Согласование УК (управляющей компанией в лице финансового директора)</li>
						<li>Согласование владельцем (право согласования на данном этапе в системе также у финансового директора УК)</li>
					</ul></p>

					<p>Согласование бюджета всегда означает согласование текущей (последней) версии. Согласования можно отозвать, если бюджет еще не был согласован на следующем этапе.</p>

				</template>

				<template v-if="$store.getters.userHasRight('pl_input')">
					<p class="display-1" id="pl-codes">Коды ввода данных P&L</p>

					<v-row>
						<v-col cols="4">
							<v-text-field
								v-model="plCodeSearch"
								append-icon="search"
								label="Поиск"
								single-line
								clearable
								hide-details
							></v-text-field>
						</v-col>
					</v-row>

					<v-data-table
						:headers="plCodeHeaders"
						:items="plCodeItems"
						:search="plCodeSearch"
						:items-per-page="10"
						:footer-props="{
							itemsPerPageText: 'Строк на странице',
							itemsPerPageOptions: [10, 25, 50, 100]
						}"
						class="elevation-1">
						<template v-slot:items="props">
							<td>{{ props.item.dc }}</td>
							<td>{{ props.item.ic }}</td>
							<td>{{ props.item.dcn }}</td>
							<td>{{ props.item.icn }}</td>
							<td>{{ props.item.openToInputCsv }}</td>
						</template>
					</v-data-table>

					<p class="display-1" id="payroll">Распределение фонда оплаты труда по отделам</p>

					<v-row>
						<v-col cols="4">
							<v-text-field
								v-model="payrollSearch"
								append-icon="search"
								label="Поиск"
								single-line
								clearable
								hide-details
							></v-text-field>
						</v-col>
					</v-row>

					<v-data-table
						:headers="payrollHeaders"
						:items="payrollItems"
						:search="payrollSearch"
						:items-per-page="-1"
						hide-default-footer
						class="elevation-1">
						<!-- <template v-slot:item="props">
							<td class="text-no-wrap">{{ props.item.dep }}</td>
							<td class="text-no-wrap">{{ props.item.subdep }}</td>
							<td class="text-no-wrap">{{ props.item.mgmt }}</td>
							<td>{{ props.item.positions }}</td>
						</template> -->
					</v-data-table>
				</template>

				<template v-if="$store.getters.userHasRight('user_mgmt')
					|| $store.getters.userHasRight('hotel_user_mgmt')">
					<p class="display-1" id="user-mgmt">Управление пользователями</p>


					<p>При добавлении пользователя имя и фамилия вводятся кириллицей. Email должен быть корпоративным и персонифицированным. Должность пользователя указывается информативно и не влияет на права. Роль пользователя определяет его права в системе. Одному пользователю можно выбрать несколько доступных отелей и несколько ролей. Доступные роли пользователей:</p>

					<v-row>
						<v-col cols="4">
							<v-text-field
								v-model="rolesSearch"
								append-icon="search"
								label="Поиск"
								single-line
								clearable
								hide-details
							></v-text-field>
						</v-col>
					</v-row>

					<v-data-table
						:headers="rolesHeaders"
						:items="rolesItems"
						:search="rolesSearch"
						:items-per-page="10"
						:footer-props="{
							itemsPerPageText: 'Строк на странице',
							itemsPerPageOptions: [10, 25, 50, 100]
						}"
						class="elevation-1">
						<!-- <template v-slot:item="props">
							<td class="text-no-wrap">{{ props.item.code }}</td>
							<td class="text-no-wrap">{{ props.item.name }}</td>
							<td>{{ props.item.descr }}</td>
						</template> -->
					</v-data-table>
				</template>
			</v-col>
		</v-row>
	</v-container>
</template>

<style scoped>
	p.headline {
		margin-top: 1em;
		margin-bottom: 1em;
	}
	p.display-1:not(:first-child) {
		margin-top: 3em;
		margin-bottom: 1em;
	}
	div.new_comment {
		display: inline-block;
		box-sizing: border-box;
		padding: 4px;
		border: 3px double blue;
		color: blue;
	}
	div.urgent {
		display: inline-block;
		box-sizing: border-box;
		padding: 4px;
		border: 3px double #ff9900;
		color: #ff9900;
	}
	div.paid,
	div.prepaid,
	div.charged {
		display: inline-block;
		box-sizing: border-box;
		padding: 4px;
		border: 3px double #1B8F00;
		color: #1B8F00;
	}
	div.rejected {
		display: inline-block;
		box-sizing: border-box;
		padding: 4px;
		border: 3px double #F25454;
		color: #F25454;
	}
	div.approved {
		display: inline-block;
		box-sizing: border-box;
		padding: 4px;
		border: 3px double #1F77B4;
		color: #1F77B4;
	}
	div.closed {
		display: inline-block;
		box-sizing: border-box;
		padding: 4px;
		border: 3px double #545758;
		color: #545758;
	}
	div.act_required {
		display: inline-block;
		box-sizing: border-box;
		padding: 4px;
		border: 3px double blue;
		color: blue;
	}
	img.copy_icon,
	img.del_icon,
	img.print_icon,
	img.new_comment_icon {
		height: 15px;
		margin-left: 3px;
		margin-right: 3px;
	}
</style>

<script>
	import {api} from '../../lib/api'
	import _ from 'lodash'

	export default {
		components: {
		},
		data: () => ({
			panel: [],
			plCodeHeaders: [
				{
					text: 'Код отдела',
		            align: 'center',
		            sortable: true,
		            value: 'dc'
				},
				{
					text: 'Код статьи',
		            align: 'center',
		            sortable: true,
		            value: 'ic'
				},
				{
					text: 'Отдел',
		            align: 'center',
		            sortable: true,
		            value: 'dcn'
				},
				{
					text: 'Статья',
		            align: 'center',
		            sortable: true,
		            value: 'icn'
				},
				{
					text: 'Открыт для импорта через CSV',
		            align: 'center',
		            sortable: true,
		            value: 'openToInputCsv'
				},
			],
			plCodeItems: [],
			plCodeSearch: '',
			payrollHeaders: [
				{
					text: 'Отдел',
		            align: 'center',
		            sortable: true,
		            value: 'dep'
				},
				{
					text: 'Подотдел',
		            align: 'center',
		            sortable: true,
		            value: 'subdep'
				},
				{
					text: 'Mgmt / Non-mgmt',
		            align: 'center',
		            sortable: true,
		            value: 'mgmt'
				},
				{
					text: 'Должности',
		            align: 'center',
		            sortable: true,
		            value: 'positions'
				},
			],
			payrollItems: [
				{
					dep: 'Rooms',
					subdep: 'Front Office',
					mgmt: 'Management',
					positions: 'Руководитель СПиР, Заместитель руководителя СПиР'
				},
				{
					dep: 'Rooms',
					subdep: 'Front Office',
					mgmt: 'Non-management',
					positions: 'Остальные сотрудники СПиР'
				},
				{
					dep: 'Rooms',
					subdep: 'Guest Services',
					mgmt: 'Non-management',
					positions: 'Консьерж'
				},
				{
					dep: 'Rooms',
					subdep: 'Housekeeping',
					mgmt: 'Management',
					positions: 'Руководитель хозяйственной службы, заместитель руководителя хозяйственной службы'
				},
				{
					dep: 'Rooms',
					subdep: 'Housekeeping',
					mgmt: 'Non-management',
					positions: 'Остальные сотрудники хозяйственной'
				},
				{
					dep: 'Rooms',
					subdep: 'Reservations',
					mgmt: 'Non-management',
					positions: 'Сотрудники отдела бронирования'
				},
				{
					dep: 'Rooms',
					subdep: 'Transportaion',
					mgmt: 'Non-management',
					positions: 'Сотрудники транспортного отдела'
				},
				{
					dep: 'Food & Beverage',
					subdep: 'Kitchen',
					mgmt: 'Management',
					positions: 'Шеф-повар, Су-шеф, Заместитель шеф-повара, Руководитель службы стюардинга'
				},
				{
					dep: 'Food & Beverage',
					subdep: 'Kitchen',
					mgmt: 'Non-management',
					positions: 'Остальные сотрудники кухни'
				},
				{
					dep: 'Food & Beverage',
					subdep: 'Service',
					mgmt: 'Management',
					positions: 'Руководитель F&B, заместитель руководителя F&B, менеджеры точек питания, банкетный менеджер'
				},
				{
					dep: 'Food & Beverage',
					subdep: 'Service',
					mgmt: 'Non-management',
					positions: 'Остальные сотрудники зала'
				},
				{
					dep: 'Food & Beverage',
					subdep: 'Banqueting',
					mgmt: 'Non-management',
					positions: 'Сотрудники, обслуживающие банкеты'
				},
				{
					dep: 'Food & Beverage',
					subdep: 'Stewarding',
					mgmt: 'Non-management',
					positions: 'Остальные сотрудники стюардинга'
				},
				{
					dep: 'Wellness & Spa',
					subdep: 'Wellness & Spa',
					mgmt: 'Management',
					positions: 'Руководитель/менеджер Wellness & Spa'
				},
				{
					dep: 'Wellness & Spa',
					subdep: 'Wellness & Spa',
					mgmt: 'Non-management',
					positions: 'Остальные сотрудники Wellness & Spa'
				},
				{
					dep: 'Administrative & General',
					subdep: 'Management',
					mgmt: 'Management',
					positions: 'Генеральный менеджер, финансовый контролер, главный бухгалтер, руководитель отдела закупок, руководитель службы безопасности, руководитель отдела кадров, тренинг менеджер, а также заместители перечисленных сотрудников'
				},
				{
					dep: 'Administrative & General',
					subdep: 'Finance',
					mgmt: 'Non-management',
					positions: 'Остальные сотрудники финансовой службы'
				},
				{
					dep: 'Administrative & General',
					subdep: 'General',
					mgmt: 'Non-management',
					positions: 'Ассистент генерального менеджера'
				},
				{
					dep: 'Administrative & General',
					subdep: 'Human Resources',
					mgmt: 'Non-management',
					positions: 'Остальные сотрудники отдела кадров'
				},
				{
					dep: 'Administrative & General',
					subdep: 'Purchasing',
					mgmt: 'Non-management',
					positions: 'Остальные сотрудники отдела закупок'
				},
				{
					dep: 'Administrative & General',
					subdep: 'Security',
					mgmt: 'Non-management',
					positions: 'Остальные сотрудники службы безопасности'
				},
			],
			payrollSearch: '',
			rolesHeaders: [
				{
					text: 'Код',
		            align: 'center',
		            sortable: true,
		            value: 'code'
				},
				{
					text: 'Название',
		            align: 'center',
		            sortable: true,
		            value: 'name'
				},
				{
					text: 'Описание',
		            align: 'center',
		            sortable: true,
		            value: 'descr'
				},
			],
			rolesItems: [],
			rolesSearch: '',
		}),
		computed: {
		},
		watch: {
		},
		created() {
			this.getPlCodes()
			this.getRoles()
		},
		methods: {
			redirect() {
				window.location.href = "#pr"
			},
			getPlCodes() {
				api.post('common/get_dc_ic', {
					nameFormatIc: "i.rus_name - i.eng_name"
				})
				.then(response => {
					this.plCodeItems = response.data.data
				})
			},
			getRoles() {
				api.post('users/get_all_roles', {
					descr: true,
					hotel: !this.$store.getters.userHo
				})
				.then(response => {
					this.rolesItems = response.data.data
				})
			}
		}
	}
</script>
